import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  [class*='dayOutsideNavigatedMonth-'] {
    visibility: hidden;
  }

  [class*="monthAndYear-"] [id*="id__"] {
    font-weight: 700;
    font-size: 14px;
  }
  [class*='ms-Callout'] [class*='ms-Dropdown-callout'] {
    max-height: 250px !important;
    overflow-y:auto !important;
  }
`;
